<p-toast key="error-message" position="top-right"></p-toast>
<p-toast key="success-message" position="top-right"></p-toast>
<div>
    <div class="card p-my-3 p-py-2">
        <div class="p-grid p-my-2">
            <div class="p-col-12">
                <h5 class="p-my-0 p-text-primary p-border-bottom">
                    User Details
                </h5>
            </div>
        </div>
        <form [formGroup]="userForm">
            <div class="p-grid p-my-2">
                <div class="p-col-5">
            <span class="p-input-icon-right p-float-label width-100">
                        <input type="text"
                               formControlName="firstName"
                               [ngClass]="togglePassword ? 'p-disabled' : 'width-100 '"
                               pInputText/>
                        <label>First Name*</label>
					</span>
                </div>
                <div class="p-col-2"></div>
                <div class="p-col-5">
                <span class="p-input-icon-right p-float-label width-100">
                        <input type="text"
                               formControlName="lastName"
                               [ngClass]="togglePassword ? 'p-disabled' : 'width-100 '"
                               pInputText/>
                        <label>Last Name*</label>
                </span>
                </div>

            </div>
            <div class="p-grid p-my-2">
                <div class="p-col-5">
            <span class="p-input-icon-right p-float-label width-100">
                        <input type="text"
                               formControlName="phoneNumber"
                               pInputText
                               [ngClass]="togglePassword ? 'p-disabled' : 'width-100 '"
                        />
                        <label>Phone Number*</label>
					</span>
                </div>
                <div class="p-col-2"></div>
                <div class="p-col-5">
                <span class="p-input-icon-right p-float-label width-100">
                        <input type="text"
                               formControlName="emailId"
                               pInputText
                               [ngClass]="!toggleDisableField || togglePassword ? 'p-disabled' : ''"/>
                    <!--                               [ngClass]="togglePassword ? 'p-disabled' : 'width-100 '"-->
                        <label>Email Id*</label>
                </span>
                </div>

            </div>
            <div class="p-grid p-my-2">
                <div class="p-col-5">
            <span class="p-input-icon-right p-float-label width-100">
                <p-password [toggleMask]="true"
                            [ngClass]="!toggleDisableField ? 'p-disabled' : ''"
                            formControlName="password"></p-password>
                        <label>Password*</label>
					</span>
                </div>
                <div class="p-col-2"></div>
                <div class="p-col-5">
                <span class="p-input-icon-right p-float-label width-100">
                    <p-password [toggleMask]="true"
                                [ngClass]="!toggleDisableField ? 'p-disabled' : ''"
                                formControlName="confirmPassword"></p-password>
                        <label>Confirm Password</label>
                </span>
                </div>

            </div>

            <div class="p-grid p-my-2">
                <div class="p-col-5">
                    <div *ngIf="optAction === 'in'">
                        <button pButton pRipple class="p-button-secondary" label="Add WhatsApp"
                                (click)="optAction = 'out'"></button>
                    </div>
                    <div *ngIf="optAction === 'out'">
                        <div class="p-grid">
                            <div class="p-col-3">

                                <p-dropdown [showClear]="true" [filter]="true" appendTo="body" filterBy="stdCode"
                                            placeholder="Select.." [options]="stdCodes"
                                            formControlName="whatsAppPhoneStdCode"
                                            optionValue="stdCode" optionLabel="stdCode"></p-dropdown>


                            </div>
                            <div class="p-col-9">
                             <span class="p-input-icon-right p-float-label width-100">
                                 <i *ngIf="userForm?.value?.whatsAppPhoneNumber"
                                    (click)="optOutForWhatsapp(userForm?.value?.whatsAppPhoneStdCode, userForm?.value?.whatsAppPhoneNumber.toString())"
                                    pRipple
                                    class="pi pi-times p-cursor"></i>
                                 <input pInputText type="number" formControlName="whatsAppPhoneNumber"/>
                                 <label>Whatsapp Number</label>
                            </span>
                                <div class="p-text-right p-pt-2">
                                    <button (click)="optInForWhatsapp(userForm?.value?.whatsAppPhoneStdCode, userForm?.value?.whatsAppPhoneNumber)"
                                            pButton pRipple class="p-button-secondary p-button-sm"
                                            label="Opt In"></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="p-col-2"></div>
                <div class="p-col-5">
                    <span class="p-input-icon-right p-float-label width-100">
                                 <input type="email" pInputText formControlName="notificationEmailId"/>
                                 <label>Notification Email</label>
                            </span>
                </div>
            </div>

            <div class="p-grid p-my-2">
                <div class="p-col-4 p-d-flex">
                    <div class="p-mt-2 p-mr-4">
                        <label>Active</label>
                        <p-inputSwitch [ngClass]="togglePassword ? 'p-disabled' : ''" formControlName="enabled"
                                       class="p-ml-2"></p-inputSwitch>
                    </div>

                </div>

            </div>

            <div class="p-grid p-ai-center p-mt-2" *ngIf="loggedInUser?.showCompanies">
                <div class="p-col-5">
                    <div class="p-field">
                        <label>Add Companies</label>
                        <p-multiSelect #multipleCompanySelection optionGroupLabel="entityName" [baseZIndex]="1000"
                                       [ngClass]="togglePassword ? 'p-disabled' : 'width-100 '"
                                       [defaultLabel]="'Select Companies'"
                                       optionLabel="entityName"
                                       [filter]="true" filterBy="entityName" [options]="businessEntityListing"
                                       formControlName="businessEntities"
                                       (onChange)="patchSelectedValue(multipleCompanySelection, 'multiSelectEntity', $event)"
                                       [placeholder]="'Select...'">
                            <ng-template pTemplate="header">
                                <div class="apply-button p-ai-center">
                                    <button (click)="multipleCompanySelection.close($event); "
                                            pButton pRipple type="button" class="p-button-icon p-m-0"
                                            icon="pi pi-check"></button>
                                </div>
                            </ng-template>
                            <ng-template pTemplate="items" let-company>
                                {{company?.entityName}} {{'&nbsp;'}} ({{company?.entityId}})
                            </ng-template>
                        </p-multiSelect>
                    </div>
                </div>
                <div class="p-col-2">
                    <p-divider layout="vertical">
                        <b>OR</b>
                    </p-divider>
                </div>
                <div class="p-col-5">
                    <div class="p-field">
                        <label>Company Groups</label>
                        <p-dropdown #company
                                    (onShow)="getBusinessEntityGroupList()"
                                    (onChange)="patchSelectedValue(company?.selectedOption, 'entityGroup', $event)"
                                    [options]="businessEntityGroupListing"
                                    [ngClass]="togglePassword ? 'p-disabled' : 'width-100 '"
                                    formControlName="groupName"
                                    optionLabel="groupName"
                                    optionValue="groupName"
                                    optionGroupLabel="groupName"
                                    styleClass="si-dropdown"
                                    appendTo="body"
                                    placeholder="Select..."
                                    emptyMessage="No Company found"
                                    readonly
                                    name="groupName"
                                    [showClear]="true"
                        >
                            <ng-template let-company pTemplate="groupName">
                                <div class="p-grid p-py-0 p-ai-center">
                                    <div class="p-col-8 p-ai-center p-pb-0">
                                        {{company.groupName}}
                                    </div>
                                    <div class="p-col-4 p-text-right p-pr-2 p-py-0">
                                        <button pButton pRipple type="button" class="p-button-text p-text-secondary"
                                                [icon]="'pi pi-pencil'" style="z-index: 100"
                                                (click)="onClickUpdateBusinessAndDomainGroup(company, 'editBusinessEntityGroup'); displayBasic = true;">
                                            <!--                                    <i class="pi pi-pencil" style="font-size: 1.5rem;z-index: 1000"></i>-->
                                        </button>
                                    </div>
                                </div>
                            </ng-template>
                            <ng-template pTemplate="footer">
                                <div class="p-p-2 divider-top p-cursor p-field-hover"
                                     (click)="onClickCreateNewGroup('company'); company.hide();" pRipple>
                                    Create New
                                </div>
                            </ng-template>
                        </p-dropdown>
                    </div>
                </div>
            </div>

            <div class="p-grid p-ai-center p-mt-2" *ngIf="loggedInUser?.showDomains">
                <div class="p-col-5">
                    <div class="p-field">
                        <label>Add Domain</label>
                        <p-multiSelect #multipleDomainSelection optionGroupLabel="domainName" [baseZIndex]="1000"
                                       [ngClass]="togglePassword ? 'p-disabled' : 'width-100 '"
                                       [defaultLabel]="'Select Domains'"
                                       optionLabel="domainName"
                                       [filter]="true" filterBy="domainName" [options]="domains"
                                       formControlName="domains"
                                       (onChange)="patchSelectedValue(multipleDomainSelection, 'multipleDomain', $event)"
                                       [placeholder]="'Select...'">
                            <ng-template pTemplate="header">
                                <div class="apply-button p-ai-center">
                                    <button (click)="multipleDomainSelection.close($event); "
                                            pButton pRipple type="button" class="p-button-icon p-m-0"
                                            icon="pi pi-check"></button>
                                </div>
                            </ng-template>
                            <ng-template pTemplate="items" let-domain>
                                {{domain?.domainName}} {{'&nbsp;'}} ({{domain?.domainId}})
                            </ng-template>
                        </p-multiSelect>
                    </div>
                </div>
                <div class="p-col-2">
                    <!--                <p-divider layout="vertical">-->
                    <!--                    <b>OR</b>-->
                    <!--                </p-divider>-->
                </div>
                <div class="p-col-5">
                    <div class="p-field">
                        <label>Domain Groups</label>
                        <p-dropdown #domainGroupList
                                    (onShow)="getDomainGroupList()"
                                    (onChange)="patchSelectedValue(domainGroupList?.selectedOption, 'domainGroup', $event)"
                                    [options]="domainGroup"
                                    [ngClass]="togglePassword ? 'p-disabled' : 'width-100 '"
                                    formControlName="domainGroupName"
                                    optionLabel="domainGroupName"
                                    optionValue="domainGroupName"
                                    optionGroupLabel="domainGroupName"
                                    styleClass="si-dropdown"
                                    appendTo="body"
                                    placeholder="Domain Group Selection"
                                    emptyMessage="No Domain found"
                                    readonly
                                    name="domainGroupName"
                                    [showClear]="true"
                        >
                            <ng-template let-domainGroupList pTemplate="domainGroupName">
                                <div class="p-grid p-ai-center">
                                    <div class="p-col-8 p-py-0">
                                        {{domainGroupList.domainGroupName}}
                                    </div>
                                    <div class="p-col-4 p-text-right p-pr-4 p-py-0">
                                        <button pButton pRipple type="button" class="p-button-text p-text-secondary"
                                                style="z-index: 100"
                                                icon="pi pi-pencil"
                                                (click)="onClickUpdateBusinessAndDomainGroup(domainGroupList, 'editDomainGroup'); displayBasic = true;">
                                        </button>
                                    </div>
                                </div>
                            </ng-template>
                            <ng-template pTemplate="footer">
                                <div class="p-p-2 divider-top p-cursor p-field-hover"
                                     (click)="onClickCreateNewGroup('domainGroupList'); domainGroupList.hide();"
                                     pRipple>
                                    Create New
                                </div>
                            </ng-template>
                        </p-dropdown>
                    </div>
                </div>
            </div>


            <div class="p-grid p-mt-3">
                <div class="p-col-5">
                    <div class="p-field">
                        <label>Roles</label>
                        <!--                (onPanelHide)="rolesSelection.close($event)"-->
                        <p-multiSelect #rolesSelection optionGroupLabel="name" [baseZIndex]="1000"
                                       autoZIndex="true"
                                       [ngClass]="togglePassword ? 'p-disabled' : 'width-100 '"
                                       [defaultLabel]="'Select..'"
                                       optionLabel="name"
                                       [filter]="true" filterBy="name" [options]="roles" formControlName="roles"
                                       [placeholder]="'Add Roles'">
                            <ng-template pTemplate="header">
                                <div class="apply-button p-ai-center">
                                    <button (click)=" selectedRoles(rolesSelection, 'multipleRoleSelection');rolesSelection.close($event);"
                                            pButton pRipple type="button" class="p-button-icon p-m-0"
                                            icon="pi pi-check"></button>
                                </div>
                            </ng-template>
                        </p-multiSelect>
                    </div>
                </div>
            </div>
            <div class="p-grid p-mt-3 p-mx-1">
                <div class="p-col-5 selected-roles-border" style="min-height: 9rem">
                    <h5 class="p-my-0 p-text-center">
                        Selected Roles !
                    </h5>
                    <div class="p-col-12" *ngFor="let role of rolesOfSelectedUser">
                        <li> {{role?.name}}</li>
                    </div>
                </div>
            </div>
            <div class="p-col-12 p-text-center p-mt-3">
                <div *ngIf="togglePassword">
                    <button class="p-button-secondary p-button-sm" pButton pRipple label="Reset Password"
                            (click)="updatePassword()">
                    </button>
                </div>
                <div *ngIf="!togglePassword">
                    <button class="p-button-secondary p-button-sm" pButton pRipple (click)="submitUserForm()"
                            [label]="currentMode === 'create' ? 'Save' : 'Update'">
                    </button>
                </div>
            </div>
        </form>


    </div>
</div>

<p-dialog [header]="toggleGroupForm ? 'Company Group' : 'Domain Group'" [(visible)]="displayBasic" [draggable]="false"
          [modal]="true" [style]="{width: '700px', backGround: '#fffff'}">
    <form [formGroup]="companyGroupListingForm" (ngSubmit)="onClickCreateBusinessGroup()" *ngIf="toggleGroupForm">
        <div>
            <div class="p-my-3">
                <span class="p-input-icon-right p-float-label width-100">
                        <input type="text"
                               formControlName="groupName"
                               pInputText class="width-100"/>
                        <label>Group Name*</label>
					</span>
            </div>
            <p-multiSelect #companySelection optionGroupLabel="entityName" [baseZIndex]="1000"
                           [defaultLabel]="'Select Company'"
                           optionLabel="entityName"
                           appendTo="body"
                           [filter]="true" filterBy="entityName" [options]="businessEntityListing"
                           formControlName="businessEntities"
                           [placeholder]="'Add Company'">
                <ng-template pTemplate="header">
                    <div class="apply-button p-ai-center">
                        <button (click)="companySelection.close($event); "
                                pButton pRipple type="button" class="p-button-icon p-m-0"
                                icon="pi pi-check"></button>
                    </div>
                </ng-template>
            </p-multiSelect>
        </div>
        <div class="p-text-center p-mt-3">
            <p-button *ngIf="!businessEntityGroupAction" type="submit">
                Submit
            </p-button>
            <p-button *ngIf="businessEntityGroupAction" type="submit">
                update
            </p-button>
        </div>
    </form>
    <form [formGroup]="domainGroupListingForm" *ngIf="!toggleGroupForm">
        <div>
            <div class="p-my-3">
                <span class="p-input-icon-right p-float-label width-100">
                        <input type="text"
                               formControlName="domainGroupName"
                               pInputText class="width-100"/>
                        <label>Group Name*</label>
					</span>
            </div>
            <p-multiSelect #multipleDomainSelection optionGroupLabel="domainName" [baseZIndex]="1000"
                           [defaultLabel]="'Select Domains'"
                           appendTo="body"
                           optionLabel="domainName"
                           [filter]="true" filterBy="domainName" [options]="domains"
                           formControlName="domainVOS"
                           (onChange)="patchSelectedValue(multipleDomainSelection, 'multipleDomain', $event)"
                           [placeholder]="'Add Domain'">
                <ng-template pTemplate="header">
                    <div class="apply-button p-ai-center">
                        <button (click)="multipleDomainSelection.close($event); "
                                pButton pRipple type="button" class="p-button-icon p-m-0"
                                icon="pi pi-check"></button>
                    </div>
                </ng-template>
            </p-multiSelect>
        </div>
        <div class="p-text-center p-mt-3">
            <p-button *ngIf="domainGroupAction" (click)="onClickCreateDomainGroup('update')">
                Update
            </p-button>
            <p-button *ngIf="!domainGroupAction" (click)="onClickCreateDomainGroup('new')">
                Submit
            </p-button>
        </div>
    </form>
</p-dialog>
